<template>
  <div class="relative rounded-full w-12 h-6 transition duration-200 ease-linear"
    :class="toggle ? 'bg-gray-300' : 'bg-gray-300'">
    <label for="toggle"
      class="absolute left-0 bg-white border-2 mb-2 w-6 h-6 rounded-full transition transform duration-100 ease-linear cursor-pointer"
      :class="toggle ? 'translate-x-full bg-link border-gray-300' : 'translate-x-0 border-gray-400 border-opacity-60'"
      @click="onToggle"></label>
    <input type="checkbox"
      class="appearance-none w-full h-full active:outline-none focus:outline-none"
      @click="onToggle"/>
  </div>
</template>

<script>
export default {
  props: {
    defaultToggle: {
      type: Boolean,
      required: true
    },
    genre: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      toggle: this.defaultToggle
    }
  },
  methods: {
    onToggle: function () {
      if (this.toggle) {
        this.$emit('toggleOff')
      } else {
        this.$emit('toggleOn')
      }
    }
  },
  computed: {
    getFilter: function () {
      return this.$store.getters['user/isFilterOn'](this.genre)
    }
  },
  watch: {
    getFilter: function (val)  {
      this.toggle = val
    }
  }
}
</script>
